import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getCampuses } from '../../api/campuses.api';
import ErrorResponse from '../../components/ErrorResponse';
import SimpleHeader from '../../components/layout/SimpleHeader';
import Loader from '../../components/Loader';
import Map from '../../components/Map';
import useAxios from '../../hooks/useAxios';
import { ICampusItem, IGetCampuses } from '../../models/campuses.model';
import { RootState } from '../../store/rootReducer';

const BusinessRegion = () => {
  const { t } = useTranslation();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // SY0004 = 지역
  const SY0004 = commonCodes.find(
    (item) => item.commonCode === 'SY0004',
  )?.detailCode;
  const { data: res, isLoading, error, execute } = useAxios<IGetCampuses>();

  const [sidoCode, setSidoCode] = useState<string>();
  const [campuses, setCampuses] = useState<ICampusItem[]>([]);

  useEffect(() => {
    execute(getCampuses());
  }, []);

  useEffect(() => {
    if (SY0004?.length && res?.data) {
      const sidoCode = SY0004[0].detailCode;
      setSidoCode(sidoCode);
      setCampuses(res.data.filter((item) => item.sidoCode === sidoCode));
    }
  }, [SY0004, res]);

  const onSetSidoCode = (value: string) => {
    setSidoCode(value);
    if (res?.data) {
      setCampuses(res.data.filter((item) => item.sidoCode === value));
    }
  };

  return (
    <>
    <SimpleHeader
      iconFile="icon-business-big.svg"
      parentMenu={t('common.menu.business')}
      currentMenu={t('business.region.title1')}
      onlyTitle={true}
    />	 
    <div className="common-search">
        <div className="search-area">
          <ul className="search-bx">
          <li>
            <label>{t('business.region.placeholder1')}</label>
            <div>
              <Select
                placeholder={t('business.region.placeholder1')}
                value={sidoCode}
                onChange={(value) => onSetSidoCode(value)}
              >
                {SY0004?.map((item: any) => {
                  return (
                    <Select.Option key={item.detailCode} value={item.detailCode}>
                      {item.korName}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
  
      <div className="mt-3">
        <Map
          height="calc(100vh - 200px)"
          level={9}
          sidoCode={sidoCode}
          campuses={campuses}
        />
      </div>      
    </div>
    </>
  );
};

export default BusinessRegion;
